import { render } from "./UtentiView.vue?vue&type=template&id=0dbd3e37"
import script from "./UtentiView.vue?vue&type=script&lang=js"
export * from "./UtentiView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__